import { useMemo } from 'react';
import { createDefaultBookingData, getBookingBreadcrumb } from '../utils/bookingUtils';

export const useBookingDataModel = (bookingData, servicePage = 'wedding-services') => {
  return useMemo(() => {
    const defaultBookingData = createDefaultBookingData();
    const bookingInput = bookingData && typeof bookingData === 'object' ? bookingData : {};
    const nestedBookingInput = bookingInput.booking && typeof bookingInput.booking === 'object' ? bookingInput.booking : {};
    const serviceInfo = bookingInput.service || nestedBookingInput.service || defaultBookingData.service;
    const packageInfo = bookingInput.package || nestedBookingInput.package || defaultBookingData.package;
    const addOnItems = Array.isArray(bookingInput.addOns)
      ? bookingInput.addOns
      : (Array.isArray(nestedBookingInput.addOns) ? nestedBookingInput.addOns : defaultBookingData.addOns);
    const bookingPricingInput = bookingInput.pricing || nestedBookingInput.pricing || null;

    const totalAmount = Number(
      bookingInput.totalPrice
      ?? nestedBookingInput.totalPrice
      ?? packageInfo.price
      ?? defaultBookingData.totalPrice
    ) || 0;

    const booking = {
      ...defaultBookingData,
      ...nestedBookingInput,
      ...bookingInput,
      service: serviceInfo,
      package: packageInfo,
      addOns: addOnItems,
      totalPrice: totalAmount
    };

    const computedAddOnTotal = addOnItems.reduce((sum, item) => sum + Number(item?.price || 0), 0);
    const pricingBreakdown = {
      baseLabel: bookingPricingInput?.baseLabel || 'Package Price',
      dakshina: Number(bookingPricingInput?.dakshina ?? packageInfo?.price ?? 0) || 0,
      platformFee: Number(bookingPricingInput?.platformFee ?? 0) || 0,
      addOns: Number(bookingPricingInput?.addOns ?? computedAddOnTotal) || 0,
      total: Number(bookingPricingInput?.total ?? totalAmount) || totalAmount,
      platformFeeNote: bookingPricingInput?.platformFeeNote || '',
      schedule: bookingPricingInput?.schedule || null
    };

    return {
      booking,
      serviceInfo,
      packageInfo,
      addOnItems,
      totalAmount,
      pricingBreakdown,
      breadcrumb: getBookingBreadcrumb(servicePage),
      bookingMode: booking?.bookingMode || 'service',
      selectedPanditName: serviceInfo?.selectedPandit?.name || null
    };
  }, [bookingData, servicePage]);
};

export default useBookingDataModel;
